import type { ChatSettings } from '../types';

export const defaults: Partial<ChatSettings> = {
  bubbleIcon: {
    url: 'https://static.elfsight.com/icons/chats-instagram-chat.svg'
  },
  buttonText: 'Chat on Instagram',
  buttonBorderRadius: 16,
  buttonColor: { type: 'native', color: 'rgb(1, 149, 246)' },
  welcomeMessage: 'Hi there!👋 <br><br> How can I help you?',
  bubbleBackgroundColor: 'rgb(255, 255, 255)',
  bubbleIconColor: 'rgb(0,0,0)',
  headerBackgroundColor: 'rgb(250, 250, 250)',
  messageBackgroundColor: 'rgb(239, 239, 239)',
  align: 'right'
};
